import {
    CHANGE_CALENDAR,
    CHANGE_CONTAINER_SELECTED_TAB,
    REMOVE_TAB,
    TAB_CHANGE,
    RENDER_MESSAGE_TYPE_CALENDAR,
    RENDER_MESSAGE_TYPE_CHAT,
    RENDER_MESSAGE_TYPE_CONTAINER,
    RENDER_MESSAGE_TYPE_DASHBOARD,
    RENDER_MESSAGE_TYPE_FORM2,
    RENDER_MESSAGE_TYPE_HTML,
    RENDER_MESSAGE_TYPE_MAP,
    RENDER_MESSAGE_TYPE_MENU,
    RENDER_MESSAGE_TYPE_SURVEY,
    RENDER_MESSAGE_TYPE_TABLE,
    RENDER_MESSAGE_TYPE_TIMELINE,
    RENDER_MESSAGE_TYPE_VIDEOCALL,
    RENDER_MESSAGE_TYPE_VIDOEPLAYER,
    RESET_CONTAINER_FIELDS,
    RESET_FORM2_FIELDS,
    BG_CALENDAR_TOOLBAR,
    RESET_TAB_STACK,
    REMOVE_PULL_DOWN_MENU,
    TAB_STATE_CHANGE,
} from "../constants";

export const initialState = {
    tabState:true,
};

const TabStackReducer = (state = initialState, action) => {
    switch (action.type) {
        case TAB_CHANGE:
        case REMOVE_TAB:
        case RENDER_MESSAGE_TYPE_MENU:
        case RENDER_MESSAGE_TYPE_CONTAINER:
        case CHANGE_CONTAINER_SELECTED_TAB:
        case RENDER_MESSAGE_TYPE_TABLE:
        case RENDER_MESSAGE_TYPE_MAP:
        case RENDER_MESSAGE_TYPE_FORM2:
        case RENDER_MESSAGE_TYPE_VIDOEPLAYER:
        case RENDER_MESSAGE_TYPE_VIDEOCALL:
        case RENDER_MESSAGE_TYPE_CALENDAR:
        case RENDER_MESSAGE_TYPE_HTML:
        case RENDER_MESSAGE_TYPE_TIMELINE:
        case RENDER_MESSAGE_TYPE_CHAT:
        case RENDER_MESSAGE_TYPE_SURVEY:
        case RENDER_MESSAGE_TYPE_DASHBOARD:
        case RESET_FORM2_FIELDS:
        case RESET_CONTAINER_FIELDS:
        case REMOVE_PULL_DOWN_MENU:
        case CHANGE_CALENDAR:
            return {
                ...state,
                ...action.data,
            };
            case TAB_STATE_CHANGE : 
            return {
                ...state,
                ...action.data
            }
        case BG_CALENDAR_TOOLBAR:
            return {
                ...state,
                bgClndrToolBarState: {
                    ...state.bgClndrToolBarState,
                    ...action.data["bgClndrToolBarState"],
                },
            };
        case RESET_TAB_STACK:
    return initialState
        default:
            return state;
    }
};

export default TabStackReducer;
